export const EXPERIENCECONSTANTS = [
  {
    name: "IQGeo",
    title: "Software Engineer \u2192 Senior Software Engineer",
    startDate: "2024",
    endDate: "Current",
    jobDescription:
      "Develop new and support existing product releases to meet the growing list of requirements for the platform product and new industry vertical applications",
    jobDuties: [
      "\u2023 Lead the implementation, customization, deployment, and support of IQGeo solutions for utility and telecom customers.",
      "\u2023 Design, develop, troubleshoot, and maintain custom software solutions using JavaScript, Python, SQL, Bash, HTML, and CSS.",
      "\u2023 Mentor developers and delivery team members, providing guidance on architecture, platform capabilities, and complex technical problem resolution.",
      "\u2023 Own customer issues end-to-end, from requirements gathering and root cause analysis through implementation, testing, deployment, and production support.",
      "\u2023 Architect and maintain CI/CD, cloud, and deployment solutions utilizing Docker, Kubernetes, Azure Pipelines, GitHub Actions, and related DevOps technologies.",
      "\u2023 Develop and support ETL processes, data migration solutions, data synchronization workflows, and integration services for customer environments.",
      "\u2023 Collaborate directly with customers during implementation, UAT, training, and go-live activities, providing technical expertise and ensuring successful project outcomes.",
    ],
    link: "https://www.iqgeo.com/",
  },
  {
    name: "The Gartrell Group",
    title: "Full Stack Developer",
    startDate: "2022",
    endDate: "2024",
    jobDescription:
      "Implement Enterprise Information System frameworks and software solutions through all project phases, including architectural design, development, and implementation.",
    jobDuties: [
      "\u2023 Developed ETL scripts for geospatial data extraction from the customer's database.",
      "\u2023 Designed UX and integrated a heatmap feature to visualize infrastructure status changes using React, jQuery, and HTML.",
      "\u2023 Developed an AWS controller in Python and JavaScript, including SQL scripting for image upload and extraction from the client server.",
      "\u2023 Collaborate with the client to define the data model structure and incorporate the design into the product.",
      "\u2023 Conducted daily development tasks in JavaScript, React, HTML, jQuery, Python, and SQL.",
      "\u2023 Optimized deployment and version control processes through the creation of bash scripts.",
    ],
    link: "https://www.gartrellgroup.com/",
  },
  {
    name: "SimBco",
    title: "Web Developer",
    startDate: "2021",
    endDate: "2022",
    jobDescription:
      "Turn design mock-ups into usable code and make changes based on client needs.",
    jobDuties: [
      "\u2023 Debugged 4-year-old C# project.",
      "\u2023 Translated Figma design into React application.",
      "\u2023 Coordinated with CEO and web designer on workflow and ticket completion.",
      "\u2023 Created Tailwind CSS custom classes for React application.",
    ],
    link: "https://www.simb.co/",
  },
  {
    name: "Rapid Response Bio Clean",
    title: "Director of Operations",
    startDate: "2017",
    endDate: "2021",
    jobDescription:
      "Provided oversite on all operational aspects of the company strategy, strategic goals, and manage flow of information to CEO and all affiliates.",
    jobDuties: [
      "\u2023 Developed company-wide workflow management system from ground up.",
      "\u2023 Coordinated with City of Portland for updated policies and procedures in relation to city-wide cleanup program.",
      "\u2023 Acquired approximately $30m in contract agreements",
      "\u2023 Assisted in growing business by approximately 175% each year of employment.",
      "\u2023 Managed up to fifty staff members and special teams.",
    ],
    link: "https://rapidresponsebioclean.com/",
  },
];
